module.exports = __webpack_public_path__ + "img/fingerprint-02.97928540.svg";